import { Urls } from 'app/scripts/controller/urls';
const { getBoardUrl } = Urls;

export const getViewUrl = (idBoard: string, viewName: string): string => {
  if (!idBoard) {
    return '#';
  }

  // Convert to lowercase (en)
  const viewNamePath = viewName.toLowerCase();

  // For every first party view except calendar the viewName matches the
  const parsedViewName =
    viewNamePath === 'calendar' ? 'calendar-view' : viewNamePath;
  const url =
    parsedViewName === 'board'
      ? getBoardUrl(idBoard)
      : getBoardUrl(idBoard, parsedViewName);
  return url;
};
